import React from "react"
import styled from "styled-components"
import PageLinks from "../constants/navLinks"
import SocialLinks from "../constants/socialLinks"
import { CgClose } from "react-icons/cg"

const Sidebar = ({ isOpen, toggleSidebar }) => {
  return (
    <Wrapper className={`${isOpen ? "show-sidebar" : ""} `}>
      <button className="close-btn" onClick={toggleSidebar}>
        <CgClose />
      </button>
      <div className="side-container">
        <PageLinks styleClass={`${isOpen ? "sidebar-links" : ""}`} />
        <SocialLinks styleClass={`${isOpen ? "sidebar-icons" : ""}`} />
      </div>
    </Wrapper>
  )
}

export default Sidebar

const Wrapper = styled.aside`
  background: var(--bg-2);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: grid;
  place-items: center;
  opacity: 0;
  transition: var(--transition);
  transform: translateX(-100%);
  @media screen and (min-width: 992px) {
    transform: translateX(-100%);
  }

  &.show-sidebar {
    opacity: 1;
    transform: translateX(0);
  }

  .sidebar-links li {
    opacity: 0;
  }
  .sidebar-links li a {
    display: block;
    text-align: center;
    text-transform: capitalize;
    color: var(--color-primary-2);
    letter-spacing: var(--spacing);
    margin-bottom: 0.5rem;
    font-size: 2rem;
    transition: var(--transition);
    border-radius: var(--radius);
  }
  .sidebar-links li a:hover {
    background: var(--bg-2);
    color: var(--color-motif-1);
  }
  .close-btn {
    position: absolute;
    right: 4.75%;
    top: 2.75%;
    font-size: 2.5rem;
    background: transparent;
    border-color: transparent;
    color: var(--color-motif-1);
    cursor: pointer;
  }

  .sidebar-links li {
    animation: slideRight 0.5s ease-in-out 0.3s forwards;
  }
  .sidebar-links li:nth-of-type(1) {
    animation-delay: 0.15s;
  }
  .sidebar-links li:nth-of-type(2) {
    animation-delay: 0.3s;
  }
  .sidebar-links li:nth-of-type(3) {
    animation-delay: 0.45s;
  }
  .sidebar-links li:nth-of-type(4) {
    animation-delay: 0.6s;
  }
  .sidebar-links li:nth-of-type(5) {
    animation-delay: 0.75s;
  }
  @keyframes slideRight {
    0% {
      transform: translateX(-200px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .sidebar-icons li a {
    color: var(--color-motif-1);
  }
  .sidebar-icons li {
    opacity: 0;
    animation: slideUp 0.5s ease-in-out 0.3s forwards;
  }
  .sidebar-icons li:nth-of-type(1) {
    animation-delay: 0.25s;
  }
  .sidebar-icons li:nth-of-type(2) {
    animation-delay: 0.5s;
  }
  @keyframes slideUp {
    0% {
      transform: translateY(200px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`
